import { ReportIds, type ReportId } from "./reports-data"

export type ReportPromoId = Extract<
  ReportId,
  "astrology" | "love-match" | "astro-map" | "soulmate-sketch" | "aura-scan"
>

/** Short promo copy for Readings tab report banners (Figma: Chats_List_Banners). */
export const REPORT_PROMO_SUBTITLES: Record<ReportPromoId, string> = {
  [ReportIds.Astrology]: "Reveal more about your love, life, timing, and next move",
  [ReportIds.LoveMatch]: "Reveal hidden signals in love, trust, and your connection",
  [ReportIds.AstroMap]: "Discover places where your energy feels strongest and aligned",
  [ReportIds.Soulmate]: "See the face the stars may be guiding toward your path",
  [ReportIds.AuraScan]: "Reveal the colors, energy patterns, and qualities of your aura",
}

export const REPORT_PROMO_SLIDE_IDS = [
  ReportIds.Astrology,
  ReportIds.LoveMatch,
  ReportIds.AstroMap,
  ReportIds.Soulmate,
  ReportIds.AuraScan,
] as const satisfies readonly ReportPromoId[]
